import { Box, Typography } from "@mui/material";
import { palette } from "../../themes/theme";
import PrimaryButton from "../PrimaryButton";
import { useNavigate } from "react-router-dom";
import { Error } from "@mui/icons-material";

const ErrorElement = (props) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100vh",
        minHeight: "100%",
        width: "100%",
        position: "absolute",
        top: 0,
        background:
          "linear-gradient(180deg, transparent, rgb(0 41 62 / 42%), #0d4663)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "inherit",
          color: palette.text.white,
          gap: 3,
        }}
      >
        <Error sx={{ fontSize: 50 }} color="error" />
        <Typography sx={{ fontSize: 30 }}>Something went wrong.</Typography>
        <Typography>
          There was a problem processing the request. Please try again.
        </Typography>

        <Box sx={{ display: "flex", gap: 2 }}>
          <PrimaryButton
            variant="contained"
            onClick={() => window.location.reload()}
          >
            Return to last page
          </PrimaryButton>
          <PrimaryButton
            variant="contained"
            onClick={() => navigate("/dashboard")}
          >
            Return to Dashboard
          </PrimaryButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorElement;
